import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { getObjectByValue } from 'utils';
import { DropdownMenuButton } from '../DropdownMenuButton/DropdownMenuButton';
import { DropdownOptions } from './DropdownOptions';
import { DropdownOptionsWrapper } from './DropdownOptionsWrapper';
import './DropdownWithOptions.scss';

export const DropdownWithOptions = (props) => {
  const {
    filterType,
    filterId,
    menuData,
    extendClass = '',
    defaultAllText,
    selectedCheckboxes = [],
    setApplyFiltersButtonDisabled = () => {},
    dropdownUpdateHandler = () => {},
  } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [chosenValues, setChosenValues] = useState(selectedCheckboxes);
  const [menuButtonLabel, setMenuButtonLabel] = useState(defaultAllText);
  const classes = `filter-dropdown ${extendClass}`;

  useEffect(() => {
    if (chosenValues.length > 1) {
      setMenuButtonLabel(`${chosenValues.length} ${filterType}s selected`);
    } else if (chosenValues.length === 1) {
      const menuName = getObjectByValue(menuData, chosenValues[0]);
      setMenuButtonLabel(menuName[0]?.name);
    } else {
      setMenuButtonLabel(defaultAllText);
    }

    /**
     * We need to return even if chosenValues is empty so that
     * the previously selected filter with the same ID
     * will be removed from previous
     * */
    dropdownUpdateHandler({ FilterId: filterId, SelectedOptions: chosenValues });
  }, [chosenValues]);

  const menuButtonClickHandler = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const menuItemClickedHandler = (event) => {
    const value = event.target.defaultValue;

    if (event.target.checked) {
      setChosenValues([...chosenValues, value]);
    } else {
      const newSelected = chosenValues.filter((item) => value !== item);
      setChosenValues(newSelected);
    }

    if (setApplyFiltersButtonDisabled) {
      setApplyFiltersButtonDisabled(false);
    }
  };

  return (
    <DropdownOptionsWrapper
      isMenuOpen={isMenuOpen}
      setIsMenuOpen={setIsMenuOpen}
      className={classes}
    >
      <DropdownMenuButton
        isMenuOpen={isMenuOpen}
        menuButtonClickHandler={menuButtonClickHandler}
        chosenValue={menuButtonLabel}
        extendClass="filter-dropdown__button"
      />
      <DropdownOptions
        isMenuOpen={isMenuOpen}
        menuData={menuData}
        chosenValues={chosenValues}
        menuItemClickedHandler={menuItemClickedHandler}
        extendClass="filter-dropdown__options"
      />
    </DropdownOptionsWrapper>
  );
};

DropdownWithOptions.propTypes = {
  filterType: PropTypes.string.isRequired,
  filterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuData: PropTypes.array.isRequired,
  extendClass: PropTypes.string,
  defaultAllText: PropTypes.string.isRequired,
  selectedCheckboxes: PropTypes.array,
  dropdownUpdateHandler: PropTypes.func,
  setApplyFiltersButtonDisabled: PropTypes.func,
};
